export class MarketingNoteRequest {
  marketingNoteId?: number;
  description?: string;
  date?: number;
  marketingId?: number;
  isNew?: boolean;
}
